import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { createGlobalStyle } from 'styled-components';

// List of allowed html elements that can be targeted for styling
const accessibilityStyleKeys = ['Button', 'A', 'Input'];

const accessibilityStyles = {};
// build up key/component pairs based on accessibilityStyleKeys for mapping with styling
for (const key of accessibilityStyleKeys) {
    accessibilityStyles[key] = createGlobalStyle`
    ${key} {
        ${propStyles};
    }
`;
}

const AccessibilityWrapperStyled = styled<any, any>('div')`
    ${propStyles};
`;

AccessibilityWrapperStyled.defaultProps = {};

interface AccessibilityWrapperProps {
    theme?: { [key: string]: React.CSSProperties };
    children?: any;
}

@observer
class AccessibilityWrapper extends React.Component<AccessibilityWrapperProps> {
    render() {
        const { children, theme } = this.props;
        return (
            <React.Fragment>
                {accessibilityStyleKeys.map(key => {
                    const GlobalStyleComponent = accessibilityStyles[key];
                    return <GlobalStyleComponent key={key} {...theme[key]} />;
                })}
                <AccessibilityWrapperStyled>
                    {children}
                </AccessibilityWrapperStyled>
            </React.Fragment>
        );
    }
}

export default withTheme(AccessibilityWrapper) as any;



// WEBPACK FOOTER //
// ./src/Components/AccessibilityWrapper.tsx